
<template>
    <v-dialog
    v-model="dialog"
    persistent
    fullscreen
    transition="dialog-bottom-transition">
        <div class="container-pay">
            <div class="header-pay">
                <span>Pagar Orden</span>

                <v-btn
                  class="btn-close-pay"
                  color="#FFFFFF"
                  variant="text"
                  @click="dialog=false">
                    <v-icon size="26">mdi-close</v-icon>
                </v-btn>

            </div>

            <div class="container-grid">

                <div class="container-form-pay border-div-pay" >
                    <span class="lbl-title-pay" v-if="crossSell.length > 0">
                        Complementos sugeridos
                    </span>

                    <div class="row-pay">
                        <div class="conteiner-cross-sell"
                            v-for="(item, index) in crossSell" :key="index">
                            <div class="row-pay">
                                <span>#{{ item.sku }}</span>
                                <span v-if="item.quantity > 0"
                                    class="container-quantity-pay">
                                    {{ item.quantity}}
                                </span>
                            </div>
                            <span class="lbl-name-cross-sell">{{ item.name }}</span>
                            <div class="row-pay">
                                <span>${{ item.price }}</span>
                                <div>
                                    <v-btn v-if="item.quantity > 0"
                                        variant="text"
                                        style="width: 30px; height: 30px;"
                                        class="rest-cross-sell"
                                        icon
                                        @click="resCrossSell(item)">
                                        <v-icon size="20"
                                            style="color: #6E6E6E">
                                            mdi-minus
                                        </v-icon>
                                    </v-btn>

                                    <v-btn variant="text"
                                        style="width: 30px; height: 30px;"
                                        class="add-cross-sell"
                                        icon
                                        @click="addCrossSell(item)">
                                        <v-icon size="20">mdi-plus</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </div>

                    <span class="lbl-title-pay"> Detalles </span>
                    <div class="row-pay">
                        <span>{{contProducts}} Items</span>
                        <span :class="{ 'disable-total': discount !== 0 }">
                            Total:
                            <span :class="{ 'line-through-total': discount !== 0 }">
                                ${{ sumTotalPartial }}
                            </span>
                        </span>
                    </div>
                    <div class="row-pay">
                        <span>
                            <v-icon>mdi-alarm</v-icon>
                            {{getMaxPrepTime}} min
                        </span>
                        <span v-if="discount != 0">
                            <v-icon color="red"
                            @click="discount = 0" >mdi-close</v-icon>
                            <v-icon>mdi-brightness-percent</v-icon>
                             {{discount}}% Total: ${{ sumTotal }}
                        </span>
                    </div>
                    <div class="row-pay" v-if="discount == 0">
                        <span></span>
                        <v-btn variant="text"
                            class="btn-pay-descount"
                            color="#FF5700"
                            @click="openDialogDiscount">
                            <v-icon>mdi-brightness-percent</v-icon>
                            <span>Agregar descuento </span>
                        </v-btn>
                    </div>

                    <div class="container-product-pay"
                        v-for="(item, index) in shoppingCart" :key="index">
                       <div class="row-pay">
                            <span>#{{ item.sku }}</span>
                            <span>x{{ item.quantity }}</span>
                            <span>${{ item.price }}</span>
                            <span>${{ item.pay_total }}</span>
                       </div>
                       <span>{{ item.name }}</span>
                       <span v-for="extra in item.extras_select" :key="extra._id">
                            +{{ extra.name }} ${{ extra.price }}
                        </span>
                        <span>{{ item.note || "" }}</span>
                    </div>

                </div>

                <div class="container-form-pay"
                style="justify-content: space-between;" >

                    <div class="container-pay-method">
                        <span class="lbl-title-pay">
                            Forma de pago
                        </span>
                        <v-btn  variant="text"
                            class="btn-pay-method"
                            :class="{ 'btn-pay-method-active': paymethod === 'transfer' }"
                            @click="paymethod = 'transfer'">
                            <v-icon>mdi-cash-check</v-icon>
                            <span>Transferencia </span>
                        </v-btn>
                        <v-btn variant="text"
                            class="btn-pay-method"
                            :class="{ 'btn-pay-method-active': paymethod === 'cash' }"
                            @click="paymethod = 'cash'; amountReceived = 0">
                            <v-icon>mdi-cash-multiple</v-icon>
                            <span>Efectivo </span>
                        </v-btn>
                        <v-btn variant="text"
                            class="btn-pay-method"
                            :class="{ 'btn-pay-method-active': paymethod === 'credit' }"
                            @click="paymethod = 'credit'">
                            <v-icon>mdi-credit-card-outline</v-icon>
                            <span>Crédito </span>
                        </v-btn>
                        <v-btn variant="text"
                            class="btn-pay-method"
                            :class="{ 'btn-pay-method-active': paymethod === 'debit' }"
                            @click="paymethod = 'debit'">
                            <v-icon>mdi-credit-card-chip-outline</v-icon>
                            <span>Débito </span>
                        </v-btn>
                        <v-btn variant="text"
                            class="btn-pay-method"
                            :class="{ 'btn-pay-method-active': paymethod === 'combined' }"
                            style="width: 100%;"
                            @click="methodCombined">
                            <v-icon>mdi-cash-plus</v-icon>
                            <span>Combinado </span>
                        </v-btn>
                    </div>

                    <div class="row-pay" v-if="paymethod === 'cash'">
                        <v-btn variant="outlined"
                            color="#FF5700"
                            @click="amountReceived += 10">
                            <span>$ 10 </span>
                        </v-btn>
                        <v-btn variant="outlined"
                            color="#FF5700"
                            @click="amountReceived += 50">
                            <span>$ 50 </span>
                        </v-btn>
                        <v-btn variant="outlined"
                            color="#FF5700"
                            @click="amountReceived += 100">
                            <span>$ 100 </span>
                        </v-btn>
                        <v-btn variant="outlined"
                            color="#FF5700"
                            @click="amountReceived += 200">
                            <span>$ 200 </span>
                        </v-btn>
                        <v-btn variant="outlined"
                            color="#FF5700"
                            @click="amountReceived += 500">
                            <span>$ 500 </span>
                        </v-btn>
                    </div>

                    <div class="row-pay" v-if="paymethod === 'cash'">
                        <div class="column-input">
                            <span>Cantidad recibida</span>
                            <v-text-field
                                v-model="amountReceived"
                                type="number"
                                style="width: 100%;"
                                density="compact"
                                variant="outlined"
                                class="no-bg"
                                append-inner-icon="mdi-close"
                                @click:append-inner="amountReceived = 0"/>
                        </div>
                        <div class="column-input">
                            <span>$ {{ getChange }}</span>
                            <span>Cambio a entregar</span>
                        </div>
                    </div>

                    <div class="container-pay-method"
                        v-if="paymethod === 'combined'">
                        <div class="column-input">
                            <span>
                                <v-icon>mdi-cash-check</v-icon>
                                Transferencia</span>
                            <v-text-field
                                v-model="payTransfer"
                                type="number"
                                style="width: 100%;"
                                density="compact"
                                variant="outlined"
                                class="no-bg"
                                append-inner-icon="mdi-close"
                                @click:append-inner="payTransfer = 0"/>
                        </div>
                        <div class="column-input">
                            <span>
                                <v-icon>mdi-cash-multiple</v-icon>
                                Efectivo</span>
                            <v-text-field
                                v-model="payCash"
                                type="number"
                                style="width: 100%;"
                                density="compact"
                                variant="outlined"
                                class="no-bg"
                                append-inner-icon="mdi-close"
                                @click:append-inner="payCash = 0"/>
                        </div>
                         <div class="column-input">
                            <span>
                                <v-icon>mdi-credit-card-outline</v-icon>
                                Crédito</span>
                            <v-text-field
                                v-model="payCredit"
                                type="number"
                                style="width: 100%;"
                                density="compact"
                                variant="outlined"
                                class="no-bg"
                                append-inner-icon="mdi-close"
                                @click:append-inner="payCredit = 0"/>
                        </div>
                        <div class="column-input">
                            <span>
                                <v-icon>mdi-credit-card-chip-outline</v-icon>
                                Débito</span>
                            <v-text-field
                                v-model="payDebit"
                                type="number"
                                style="width: 100%;"
                                density="compact"
                                variant="outlined"
                                class="no-bg"
                                append-inner-icon="mdi-close"
                                @click:append-inner="payDebit = 0"/>
                        </div>
                    </div>

                    <v-btn
                        style="width: 100%;"
                        color="#FF5700"
                        :disabled="btnDisabled"
                        @click="addOrder">
                        Registrar orden  ${{ sumTotal }}
                    </v-btn>

                </div>

            </div>

        </div>
    </v-dialog>

    <dialog-discount
        ref="discountDialog"
        @okBtn="getDiscount"/>

</template>

<script>
import catalogApi from '@/api/catalogApi'
import DialogDiscount from '../dialogs/DialogDiscount.vue'
import ordersApi from '@/api/ordersApi'
import paymentsApi from '@/api/paymentsApi'

export default {
  name: 'CommerciaVueNewOrderPay',
  emits: ['closePay'],
  components: {
    DialogDiscount
  },
  data () {
    return {
      dialog: false,
      shoppingCart: [],
      crossSell: [],
      discount: 0,
      paymethod: '',
      amountReceived: 0,
      totalChange: 0,
      payTransfer: 0,
      payCash: 0,
      payCredit: 0,
      payDebit: 0
    }
  },

  computed: {
    contProducts () {
      const cartTotal = this.shoppingCart.reduce(
        (total, product) => total + product.quantity, 0
      )
      const crossSellTotal = this.crossSell.reduce(
        (total, product) => total + product.quantity, 0
      )
      return cartTotal + crossSellTotal
    },
    sumTotalPartial () {
      const cartTotal = this.shoppingCart.reduce((total, product) => {
        const extrasTotal = (product.extras_select || []).reduce((sum, extra) => {
          return sum + (extra.price || 0)
        }, 0)
        return total + product.pay_total + extrasTotal
      }, 0)
      const crossSellTotal = this.crossSell.reduce(
        (total, product) => total + product.pay_total, 0
      )
      return cartTotal + crossSellTotal
    },
    sumTotal () {
      return this.getTotalPay()
    },
    getChange () {
      const total = this.getTotalPay()
      const change = this.amountReceived - total
      return change >= 0 ? change : '-'
    },
    getMaxPrepTime () {
      const allProducts = [...this.shoppingCart, ...(this.crossSell || [])]
      return allProducts.reduce((max, product) => {
        if (product.quantity > 0 && typeof product.prep_time === 'number') {
          return product.prep_time > max ? product.prep_time : max
        }
        return max
      }, 0)
    },
    btnDisabled () {
      const total = this.getTotalPay()

      if (this.paymethod === '') return true

      if (this.paymethod === 'combined') {
        const totalPaid =
            Number(this.payTransfer) +
            Number(this.payCash) +
            Number(this.payCredit) +
            Number(this.payDebit)
        return totalPaid !== total
      }

      return false
    }
  },

  methods: {
    getTotalPay () {
      const cartTotal = this.shoppingCart.reduce((total, product) => {
        const extrasTotal = (product.extras_select || []).reduce((sum, extra) => {
          return sum + (extra.price || 0)
        }, 0)
        return total + product.pay_total + extrasTotal
      }, 0)
      const crossSellTotal = this.crossSell.reduce(
        (total, product) => total + product.pay_total, 0
      )

      const total = cartTotal + crossSellTotal
      const discountAmount = (this.discount / 100) * total

      return total - discountAmount
    },
    open (item) {
      this.dialog = true
      this.shoppingCart = item
      this.paymethod = ''
      this.getCrossSell()
    },
    disabledBtn () {
      return true
    },
    getTotal () { return 0 },
    getCrossSell () {
      this.crossSell = []
      const obj = []
      for (const product of this.shoppingCart) {
        if (product.cross_sell) {
          for (const item of product.cross_sell) {
            const notInCart = !this.shoppingCart.some(p => p._id === item)
            const notInObj = !obj.includes(item)
            if (notInObj && notInCart) {
              obj.push(item)
            }
          }
        }
      }
      this.getProduct(obj)
    },
    addCrossSell (item) {
      item.quantity += 1
      item.pay_total = item.quantity * item.price
    },
    resCrossSell (item) {
      if (item.quantity > 0) {
        item.quantity -= 1
        item.pay_total = item.quantity * item.price
      }
    },
    async getProduct (obj) {
      const items = obj.slice(0, 2)
      for (const item of items) {
        const product = await catalogApi.byId(item)
        const simplifiedProduct = {
          _id: product._id,
          name: product.name,
          price: product.price,
          category: product.category,
          sku: product.sku,
          quantity: 0,
          extras: [],
          note: '',
          pay_total: 0,
          prep_time: product.prep_time,
          promo_price: product.promo_price
        }
        this.crossSell.push(simplifiedProduct)
      }
    },
    openDialogDiscount () {
      this.$refs.discountDialog.open()
    },
    getDiscount (value) {
      this.discount = value
    },
    methodCombined () {
      this.paymethod = 'combined'
      this.payTransfer = 0
      this.payCash = 0
      this.payCredit = 0
      this.payDebit = 0
    },

    async addOrder () {
      const timestamp = Date.now()
      const products = []
      let business = ''
      let terminal = ''

      for (const item of this.shoppingCart) {
        business = item.business
        terminal = item.terminal
        products.push({
          _id: item._id,
          name: item.name,
          price: item.price,
          category: item.category,
          sku: item.sku,
          quantity: item.quantity,
          extras: item.extras_select,
          note: item.note,
          prep_time: item.prep_time
        })
      }

      for (const item of this.crossSell) {
        if (item.quantity > 0) {
          products.push({
            _id: item._id,
            name: item.name,
            price: item.price,
            category: item.category,
            sku: item.sku,
            quantity: item.quantity,
            extras: item.extras,
            note: item.note,
            prep_time: item.prep_time
          })
        }
      }

      const amount = this.getTotalPay()

      const order = {
        alias: timestamp,
        order_status: 'Entregado',
        terminal: terminal,
        business: business,
        folio: timestamp,
        products: products,
        amount: amount,
        discount: this.discount
      }

      // crear orden
      const res = await ordersApi.add(order)
      // crear pagos
      if (res) {
        if (this.paymethod !== 'combined') {
          await this.savePayment(this.paymethod,
            res._id, amount, this.paymethod + timestamp)
        } else {
          if (this.payCash > 0) {
            await this.savePayment('cash',
              res._id, this.payCash, 'cash' + timestamp)
          }
          if (this.payCredit > 0) {
            await this.savePayment('credit',
              res._id, this.payCredit, 'credit' + timestamp)
          }
          if (this.payDebit > 0) {
            await this.savePayment('debit',
              res._id, this.payDebit, 'debit' + timestamp)
          }
          if (this.payTransfer > 0) {
            await this.savePayment('transfer',
              res._id, this.payTransfer, 'transfer' + timestamp)
          }
        }
      }

      // cerrar ventanas
      this.dialog = false
      this.$emit('closePay')
    },
    async savePayment (type, order, amount, alias) {
      const payment = {
        alias: alias,
        order: order,
        method: type,
        amount: amount
      }
      const pay = await paymentsApi.add(payment)
      console.log(pay)
    }
  }
}
</script>

<style scoped>
    @import '@/assets/styles/pay.css';
    @import '@/assets/styles/inputs.css';
</style>
